import React, { useState, useEffect } from 'react';

type TypewriterProps = {
  text: string;
  delay: number;
  onChange?: () => void;
  done?: (reset: () => void) => void;
}

const Typewriter = ({ onChange, text, delay, done }: TypewriterProps) => {
  const [currentText, setCurrentText] = useState("");
  const [currentIndex, setCurrentIndex] = useState(0);

  function reset() {
    setCurrentText("")
    setCurrentIndex(0)
  }

  useEffect(() => {
    if (currentIndex < text.length) {
      const timeout = setTimeout(() => {
        setCurrentText(prevText => prevText + text[currentIndex]);
        setCurrentIndex(prevIndex => prevIndex + 1);

        if (!!onChange) {
          onChange()
        }
      }, delay);

      return () => clearTimeout(timeout);
    } else if (!!done) {
      done(reset);
    }
  }, [currentIndex, delay, text]);

  if (!text) {
    return null
  }

  return <>{currentText}</>;
};

export default Typewriter;